var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixCalendarV3Event from '@wix/ambassador-calendar-v3-event/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Status;
(function (Status) {
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Event is confirmed. Default value. */
    Status["CONFIRMED"] = "CONFIRMED";
    /** DEPRECATED! AND WILL BE REMOVED SOON */
    Status["PENDING_CONFIRMATION"] = "PENDING_CONFIRMATION";
    /** Event has been cancelled. */
    Status["CANCELLED"] = "CANCELLED";
})(Status || (Status = {}));
export var RecurrenceType;
(function (RecurrenceType) {
    RecurrenceType["UNKNOWN_RECURRENCE_TYPE"] = "UNKNOWN_RECURRENCE_TYPE";
    /** No recurrence, i.e the event is a single event instance. Default. */
    RecurrenceType["NONE"] = "NONE";
    /** The event is the recurrence master defining the recurrence rule, which is the repeat pattern for the events. */
    RecurrenceType["MASTER"] = "MASTER";
    /** The event is an instance of a recurring event. Read only. */
    RecurrenceType["INSTANCE"] = "INSTANCE";
    /** The event is an exceptional instance of a recurring event. Read only. */
    RecurrenceType["EXCEPTION"] = "EXCEPTION";
})(RecurrenceType || (RecurrenceType = {}));
export var Frequency;
(function (Frequency) {
    Frequency["UNKNOWN_FREQUENCY"] = "UNKNOWN_FREQUENCY";
    /** The event repeats every few weeks. */
    Frequency["WEEKLY"] = "WEEKLY";
})(Frequency || (Frequency = {}));
export var Day;
(function (Day) {
    Day["MONDAY"] = "MONDAY";
    Day["TUESDAY"] = "TUESDAY";
    Day["WEDNESDAY"] = "WEDNESDAY";
    Day["THURSDAY"] = "THURSDAY";
    Day["FRIDAY"] = "FRIDAY";
    Day["SATURDAY"] = "SATURDAY";
    Day["SUNDAY"] = "SUNDAY";
})(Day || (Day = {}));
export var Transparency;
(function (Transparency) {
    Transparency["UNKNOWN_TRANSPARENCY"] = "UNKNOWN_TRANSPARENCY";
    /** The event block time. Default. */
    Transparency["OPAQUE"] = "OPAQUE";
    /** The event does not block the time. */
    Transparency["TRANSPARENT"] = "TRANSPARENT";
})(Transparency || (Transparency = {}));
export var LocationType;
(function (LocationType) {
    LocationType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    /** The event takes place at the business location. */
    LocationType["BUSINESS"] = "BUSINESS";
    /** The event takes place at the customer location. */
    LocationType["CUSTOMER"] = "CUSTOMER";
    /** The event takes place at the custom location. */
    LocationType["CUSTOM"] = "CUSTOM";
})(LocationType || (LocationType = {}));
export var Role;
(function (Role) {
    Role["UNKNOWN_ROLE"] = "UNKNOWN_ROLE";
    /** Role grants full write and read access. */
    Role["WRITER"] = "WRITER";
    /** Role grants full read access and permission to edit notes. */
    Role["COMMENTER"] = "COMMENTER";
})(Role || (Role = {}));
export var ParticipantsStatus;
(function (ParticipantsStatus) {
    ParticipantsStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** All participants are confirmed. */
    ParticipantsStatus["CONFIRMED"] = "CONFIRMED";
    /** Some participants are pending confirmation. */
    ParticipantsStatus["PENDING_CONFIRMATION"] = "PENDING_CONFIRMATION";
})(ParticipantsStatus || (ParticipantsStatus = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    Type["ZOOM"] = "ZOOM";
    Type["CUSTOM"] = "CUSTOM";
})(Type || (Type = {}));
export var Field;
(function (Field) {
    Field["UNKNOWN_FIELD"] = "UNKNOWN_FIELD";
    /** The title is inherited from the schedule or the recurring event. */
    Field["TITLE"] = "TITLE";
    /** The time zone is inherited from the schedule or the recurring event. */
    Field["TIME_ZONE"] = "TIME_ZONE";
    /** The time is inherited from the recurring event. */
    Field["TIME"] = "TIME";
    /** The location is inherited from the schedule or the recurring event. */
    Field["LOCATION"] = "LOCATION";
    /** The resources are inherited from the recurring event. */
    Field["RESOURCES"] = "RESOURCES";
    /** The capacity is inherited from the schedule or the recurring event. */
    Field["CAPACITY"] = "CAPACITY";
    /** The participants are inherited from the recurring event. */
    Field["PARTICIPANTS"] = "PARTICIPANTS";
    /** The conferencing details are inherited from the schedule or the recurring event. */
    Field["CONFERENCING_DETAILS"] = "CONFERENCING_DETAILS";
})(Field || (Field = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["WIX_USER"] = "WIX_USER";
})(IdentityType || (IdentityType = {}));
export var RequestedFields;
(function (RequestedFields) {
    RequestedFields["UNKNOWN_REQUESTED_FIELDS"] = "UNKNOWN_REQUESTED_FIELDS";
    /**
     * Include fields containing personal information.
     * Requires the `CALENDAR.EVENT_READ_PI` additional permission.
     */
    RequestedFields["PI_FIELDS"] = "PI_FIELDS";
    /**
     * Include fields containing personal information for events the current caller has access to.
     * See `event.permissions` for more details.
     */
    RequestedFields["OWN_PI_FIELDS"] = "OWN_PI_FIELDS";
})(RequestedFields || (RequestedFields = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
/** Enumerates the days of the week. */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
const _bulkCancelEventRequest = {};
const _bulkCancelEventResponse = {};
const _bulkCreateEventRequest = {};
const _bulkCreateEventResponse = {};
const _bulkUpdateEventRequest = {};
const _bulkUpdateEventResponse = {};
const _cancelEventRequest = {};
const _cancelEventResponse = {};
const _createEventRequest = {};
const _createEventResponse = {};
const _getEventRequest = {};
const _getEventResponse = {};
const _listEventsByContactIdRequest = {};
const _listEventsByContactIdResponse = {};
const _listEventsByMemberIdRequest = {};
const _listEventsByMemberIdResponse = {};
const _listEventsRequest = {};
const _listEventsResponse = {};
const _queryEventsRequest = {};
const _queryEventsResponse = {};
const _restoreEventDefaultsRequest = {};
const _restoreEventDefaultsResponse = {};
const _splitRecurringEventRequest = {};
const _splitRecurringEventResponse = {};
const _updateEventRequest = {};
const _updateEventResponse = {};
/**
 * Retrieves an event by ID.
 * @param eventId - The ID of the event to retrieve. Required.
 * @public
 * @documentationMaturity preview
 * @requiredField eventId
 * @returns The event.
 */
export function getEvent(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            timeZone: '$[1].timeZone',
            fields: '$[1].fields',
        };
        const responseTransformation = '$.event';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getEventResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixCalendarV3Event.getEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of events by their IDs.
 * @param eventIds - The IDs of the events to retrieve.
 * @public
 * @documentationMaturity preview
 * @requiredField eventIds
 */
export function listEvents(eventIds, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventIds: '$[0]',
            timeZone: '$[1].timeZone',
            fields: '$[1].fields',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listEventsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listEventsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#events']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventIds, options]);
        const reqOpts = ambassadorWixCalendarV3Event.listEvents(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventIds',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Query events given the provided time range, filters and paging.
 *
 * Sort: by default events are sorted by their start date in ascending order. Events can also be sorted by their end date in descending order.
 * > __Note__ Querying by IDs is not supported, please use the GetEvent or ListEvents APIs instead.
 * @public
 * @documentationMaturity preview
 */
export function queryEvents(options) {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.events',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[1];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryEventsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryEventsResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#events']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixCalendarV3Event.queryEvents(Object.assign(Object.assign({}, payload), (options !== null && options !== void 0 ? options : {})));
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Creates an event.
 * @param event - The event to create.
 * @public
 * @documentationMaturity preview
 * @requiredField event
 * @requiredField event.conferencingDetails.guestUrl
 * @requiredField event.conferencingDetails.hostUrl
 * @requiredField event.conferencingDetails.type
 * @requiredField event.end
 * @requiredField event.end.localDate
 * @requiredField event.location.type
 * @requiredField event.participants.list.name
 * @requiredField event.recurrenceRule.days
 * @requiredField event.recurrenceRule.frequency
 * @requiredField event.recurrenceRule.until.localDate
 * @requiredField event.resources._id
 * @requiredField event.scheduleId
 * @requiredField event.start
 * @requiredField event.start.localDate
 * @adminMethod
 * @returns The created event.
 */
export function createEvent(event, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            event: '$[0]',
            fieldmask: '$[1].fieldmask',
            timeZone: '$[1].timeZone',
            idempotencyKey: '$[1].idempotencyKey',
        };
        const responseTransformation = '$.event';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createEventResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([event, options]);
        const reqOpts = ambassadorWixCalendarV3Event.createEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'event',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates multiple events in bulk.
 * @param events - The events to create.
 * @public
 * @documentationMaturity preview
 * @requiredField events
 * @requiredField events.event
 * @requiredField events.event.conferencingDetails.guestUrl
 * @requiredField events.event.conferencingDetails.hostUrl
 * @requiredField events.event.conferencingDetails.type
 * @requiredField events.event.end
 * @requiredField events.event.end.localDate
 * @requiredField events.event.location.type
 * @requiredField events.event.participants.list.name
 * @requiredField events.event.recurrenceRule.days
 * @requiredField events.event.recurrenceRule.frequency
 * @requiredField events.event.recurrenceRule.until.localDate
 * @requiredField events.event.resources._id
 * @requiredField events.event.scheduleId
 * @requiredField events.event.start
 * @requiredField events.event.start.localDate
 * @adminMethod
 */
export function bulkCreateEvent(events, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            events: '$[0]',
            returnEntity: '$[1].returnEntity',
            timeZone: '$[1].timeZone',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkCreateEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#events.event']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkCreateEventResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#results.item']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([events, options]);
        const reqOpts = ambassadorWixCalendarV3Event.bulkCreateEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'events',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates an event.
 * @param _id - The event ID.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField event
 * @requiredField event.conferencingDetails.guestUrl
 * @requiredField event.conferencingDetails.hostUrl
 * @requiredField event.conferencingDetails.type
 * @requiredField event.end.localDate
 * @requiredField event.location.type
 * @requiredField event.participants.list.name
 * @requiredField event.recurrenceRule.days
 * @requiredField event.recurrenceRule.frequency
 * @requiredField event.recurrenceRule.until.localDate
 * @requiredField event.resources._id
 * @requiredField event.revision
 * @requiredField event.start.localDate
 * @adminMethod
 * @returns The updated event.
 */
export function updateEvent(_id, event, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            event: { '*': '$[1]', id: '$[0]' },
            fieldmask: '$[2].fieldmask',
            participantNotification: '$[2].participantNotification',
            timeZone: '$[2].timeZone',
        };
        const responseTransformation = '$.event';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateEventResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, event, options]);
        const reqOpts = ambassadorWixCalendarV3Event.updateEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'event',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates multiple events in bulk.
 * @param events - The events to update.
 * @public
 * @documentationMaturity preview
 * @requiredField events
 * @requiredField events.event
 * @requiredField events.event._id
 * @requiredField events.event.conferencingDetails.guestUrl
 * @requiredField events.event.conferencingDetails.hostUrl
 * @requiredField events.event.conferencingDetails.type
 * @requiredField events.event.end.localDate
 * @requiredField events.event.location.type
 * @requiredField events.event.participants.list.name
 * @requiredField events.event.recurrenceRule.days
 * @requiredField events.event.recurrenceRule.frequency
 * @requiredField events.event.recurrenceRule.until.localDate
 * @requiredField events.event.resources._id
 * @requiredField events.event.revision
 * @requiredField events.event.start.localDate
 * @adminMethod
 */
export function bulkUpdateEvent(events, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            events: '$[0]',
            returnEntity: '$[1].returnEntity',
            participantNotification: '$[1].participantNotification',
            timeZone: '$[1].timeZone',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkUpdateEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#events.event']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkUpdateEventResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#results.item']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([events, options]);
        const reqOpts = ambassadorWixCalendarV3Event.bulkUpdateEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'events',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Restore default event values from the schedule or the recurring event.
 * @param eventId - The ID of the event.
 * @param fields - The fields for which to restore default values.
 * @public
 * @documentationMaturity preview
 * @requiredField eventId
 * @requiredField fields
 * @adminMethod
 */
export function restoreEventDefaults(eventId, fields, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            fields: '$[1]',
            participantNotification: '$[2].participantNotification',
            timeZone: '$[2].timeZone',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _restoreEventDefaultsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _restoreEventDefaultsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, fields, options]);
        const reqOpts = ambassadorWixCalendarV3Event.restoreEventDefaults(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'fields',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Splits a recurring event at a provided future date into two recurring events.
 *
 * Recurring event instances starting at or after the split date will belong to the new recurring event.
 *
 * Upon split, the following happens:
 * - The recurring event is set to end in the last instance before the split date.
 * - A new recurring event is created which set to start from the next instance starting at/after the split date.
 * - Recurring event exceptions which start at/after the split date are updated with the new recurring event ID.
 *
 * The split date must be a future date between two instances of the recurring event.
 * @param recurringEventId - The ID of the recurring event to split.
 * @param splitLocalDate - The ISO-8601 local date where the recurring event is to be split.
 * Must be a future date.
 * Must be between two instances of the recurring event.
 * @public
 * @documentationMaturity preview
 * @requiredField recurringEventId
 * @requiredField splitLocalDate
 * @adminMethod
 */
export function splitRecurringEvent(recurringEventId, splitLocalDate, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            recurringEventId: '$[0]',
            splitLocalDate: '$[1]',
            timeZone: '$[2].timeZone',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _splitRecurringEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _splitRecurringEventResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [
                    ...[
                        'updatedRecurringEventEndingBeforeSplit',
                        'newRecurringEventStartingFromSplit',
                    ],
                ],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([
            recurringEventId,
            splitLocalDate,
            options,
        ]);
        const reqOpts = ambassadorWixCalendarV3Event.splitRecurringEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'recurringEventId',
                'splitLocalDate',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Cancels an event.
 * @param eventId - The ID of the event to cancel.
 * @public
 * @documentationMaturity preview
 * @requiredField eventId
 * @adminMethod
 */
export function cancelEvent(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            participantNotification: '$[1].participantNotification',
            timeZone: '$[1].timeZone',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _cancelEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _cancelEventResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['event']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixCalendarV3Event.cancelEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Cancels multiple events in bulk.
 * @param eventIds - The IDs of the events to cancel.
 * @public
 * @documentationMaturity preview
 * @requiredField eventIds
 * @adminMethod
 */
export function bulkCancelEvent(eventIds, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventIds: '$[0]',
            returnEntity: '$[1].returnEntity',
            participantNotification: '$[1].participantNotification',
            timeZone: '$[1].timeZone',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkCancelEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkCancelEventResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#results.item']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventIds, options]);
        const reqOpts = ambassadorWixCalendarV3Event.bulkCancelEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventIds',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of events by a participant's contact ID.
 *
 * Limits:
 * - Max time range is 1 year.
 * @param contactId - The ID of the contact participating in the events.
 * Required, unless `cursorPaging` is provided.
 * @public
 * @documentationMaturity preview
 * @requiredField contactId
 * @adminMethod
 */
export function listEventsByContactId(contactId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            contactId: '$[0]',
            fromLocalDate: '$[1].fromLocalDate',
            toLocalDate: '$[1].toLocalDate',
            timeZone: '$[1].timeZone',
            appId: '$[1].appId',
            cursorPaging: '$[1].cursorPaging',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listEventsByContactIdRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listEventsByContactIdResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#events']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([contactId, options]);
        const reqOpts = ambassadorWixCalendarV3Event.listEventsByContactId(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'contactId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of events by a participant's member ID.
 *
 * Limits:
 * - Max time range is 1 year.
 * @param memberId - The ID of the member participating in the events.
 *
 * Can be `me` for the currently logged-in member ID.
 * To retrieve other member events the `CALENDAR.EVENT_READ_PI` permission is required.
 *
 * Required, unless `cursorPaging` is provided.
 * @public
 * @documentationMaturity preview
 * @requiredField memberId
 */
export function listEventsByMemberId(memberId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            memberId: '$[0]',
            fromLocalDate: '$[1].fromLocalDate',
            toLocalDate: '$[1].toLocalDate',
            timeZone: '$[1].timeZone',
            appId: '$[1].appId',
            cursorPaging: '$[1].cursorPaging',
            eventIds: '$[1].eventIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listEventsByMemberIdRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listEventsByMemberIdResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#events']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([memberId, options]);
        const reqOpts = ambassadorWixCalendarV3Event.listEventsByMemberId(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'memberId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=calendar-v3-event.universal.js.map